module.exports = __webpack_public_path__ + "fonts/videogular.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/videogular.woff
// module id = ./node_modules/@ps/common-core/dist/fonts/videogular.woff
// module chunks = 1